module.exports = __webpack_public_path__ + "img/f4-2-1.93f7d5a6.png";